module.exports = __webpack_public_path__ + "static/media/block-view.2960fd28.svg";